import { render, staticRenderFns } from "./register.vue?vue&type=template&id=bc0b7d42&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=bc0b7d42&prod&lang=css"
import style1 from "./register.vue?vue&type=style&index=1&id=bc0b7d42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0b7d42",
  null
  
)

export default component.exports